
import React, { Component } from 'react'
import _ from 'lodash'
import Pack from '../Pack'
import Utils from '../../lib/utils'
// import { styles } from 'ansi-colors';
// import styles from './index.module.less'

function Content (props) {
  const type = !props.isHorizontal ? 'vertical' : 'horizontal'
  const changeNum = props.changeNum || 0
  return (
    <div className={`g-row ${(changeNum > 0 && Math.floor(props.index / props.row) !== props.changeIndex) ? 'change-hide' : ''} `} >
      {
        props.list.map((item, index) => (
          index <= props.len - 1 && (<div key={index} className={(index === props.len - 1) ? 'g-col m-hide' : (index > props.len - 4) ? 'g-col  s-hide' : 'g-col'}>
            <div className='g-box'>
              <Pack data={item} index={index} rank={props.rank} isOneLineTitle={props.isOneLineTitle} type={type} spm={Utils.getSpmD(index)} />
            </div>
          </div>)
        ))}
    </div>)
}

class PackList extends Component {
  static defaultProps = {
    list: [],
    len: 7,
    row: 2,
    isHorizontal: true,
    rank: false
  }
  shouldComponentUpdate (nextProps, nextState) {
    if (nextProps.list.length === this.props.list.length && !this.props.changeNum) {
      return false
    } else {
      return true
    }
  }
  render () {
    if (!this.props.list || this.props.list.length === 0) {
      return ''
    }
    let rowData = _.chunk(this.props.list, this.props.len)
    let _rowsClass = this.props.row > 1 ? 'g-rows' : ''
    return (
      <div className={_rowsClass} >
        {
          rowData.map((item, index) => (
            index < rowData.length && (index < this.props.row || index < (this.props.changeNum * this.props.row)) && <Content isHorizontal={this.props.isHorizontal} isOneLineTitle={this.props.isOneLineTitle} rank={this.props.rank} key={index} index={index} list={item} len={this.props.len} changeIndex={this.props.changeIndex} changeNum={this.props.changeNum} row={this.props.row} />
          ))
        }
      </div>
    )
  }
}

export default PackList
